import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  modalHeader: {
    id: 'SFkIkv',
    defaultMessage: '{targetName} - Sync Details',
    description: 'Header for the sync details modal',
  },
  sku: {
    id: 'jttP1f',
    defaultMessage: 'SKU',
    description: 'SKU column header',
  },
  quantity: {
    id: '6ky6K2',
    defaultMessage: 'Quantity',
    description: 'Quantity column header',
  },
  errorMessage: {
    id: 'o7VJYC',
    defaultMessage: 'Error Message',
    description: 'Error message column header',
  },
  targetNameHeader: {
    id: 'cdcI7n',
    defaultMessage: 'Target Name',
    description: 'Target name header',
  },
  lastSync: {
    id: '/E32SF',
    defaultMessage: 'Last Sync',
    description: 'Last sync header',
  },
  skusUpdated: {
    id: 'NWd/hY',
    defaultMessage: 'SKUs Updated',
    description: 'SKUs updated header',
  },
  errors: {
    id: 'BIOIBt',
    defaultMessage: 'Errors',
    description: 'Errors header',
  },
  jobStatus: {
    id: 'xk3uel',
    defaultMessage: 'Job Status',
    description: 'Shows the status of a sync job',
  },
  bannerInfo: {
    id: 'iEJdj8',
    defaultMessage: 'For more information on how to resolve these errors, please refer to our KB article.',
    description: 'Banner info text',
  },
  bannerLink: {
    id: 'DOrryw',
    defaultMessage: '<a>Learn more</a>',
    description: 'Button leading to article',
  },
});
